module.exports = __webpack_public_path__ + "eca759b25550ece42b965a555f08f6fe.svg";